const baseURL = 'https://indumentaria.encatalogo.com/';

export default baseURL;
